module.exports = __webpack_public_path__ + "img/logo_fdff.75eae3b1.jpg";